import { render, staticRenderFns } from "./OwnerList.vue?vue&type=template&id=514dfb54"
import script from "./OwnerList.vue?vue&type=script&lang=js"
export * from "./OwnerList.vue?vue&type=script&lang=js"
import style0 from "./OwnerList.vue?vue&type=style&index=0&id=514dfb54&prod&lang=sass&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports